export const COMMON_PAGE_FILED_lIST = "COMMON_PAGE_FILED_lIST"
export const  COMMON_PAGE_FILED_lIST_SUCCESS='COMMON_PAGE_FILED_lIST_SUCCESS'

export const COMMON_PAGE_FILED = "COMMON_PAGE_FILED"
export const  COMMON_PAGE_FILED_SUCCESS='COMMON_PAGE_FILED_SUCCESS'
